import { StaticLayout } from './static-layout'

export function RoadmapPage() {
  return (
    <StaticLayout title="Roadmap" description="What we&apos;re working on next.">
      <h2>In progress</h2>
      <ul>
        <li>Auto-save with visible status indicator</li>
        <li>Account-level password change endpoint (currently via email reset)</li>
        <li>Document folders / tagging</li>
      </ul>

      <h2>Planned</h2>
      <ul>
        <li>Editable profile (currently read-only)</li>
        <li>Email notifications for shared-doc activity</li>
        <li>Diff view for version history</li>
        <li>Import from .md / .html files</li>
      </ul>

      <h2>Considering</h2>
      <ul>
        <li>Mobile app</li>
        <li>Offline editing with sync</li>
        <li>Public document gallery</li>
      </ul>

      <p>
        Got something you&apos;d like to see prioritised? Tell us on the{' '}
        <a href="/contact">contact page</a>.
      </p>
    </StaticLayout>
  )
}
